import {
  ArrayToFilterListItemBuilder,
  asDate,
  FieldMetadataCollection,
  FieldMetadataCollectionBuilder,
  FilterFieldProvider,
  FilterOperators, FilterService, ListTypeFilterInstance,
  mapDate, selectByListType,
} from "@feature/common";
import {Field, Rule, RuleSet}from '@feature/_app_modules/ngx-angular-query-builder/query-builder/query-builder.interfaces';
import {MfsUser} from "@mfs/user-admin/models/mfs-user";
import { MftUser } from "@feature/_app_modules/mojo-for-tenants/user-admin/models/mft-user";
import {ListType} from "@common/enums/list-type";
import { createSelector } from "@ngrx/store";

type MfsOrMftUser = MfsUser | MftUser;

export class UserFilterFieldProvider
  implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(
    private readonly data: MfsOrMftUser[]
  ) {
    const columnDataBuilder = new ArrayToFilterListItemBuilder(data ?? []);

    const addStringProp = (k: string) =>
      columnDataBuilder.forProperty(k, k as keyof MfsOrMftUser, (user: MfsOrMftUser) => user[k]);

    const addDateProp = (k: string) =>
      columnDataBuilder.add(k, (x: any) => asDate(x[k]), mapDate(k));

    addStringProp('email');
    addStringProp('role');
    addStringProp('linkedBy');
    addStringProp('linkedTo');
    addStringProp('withAccessTo');
    addStringProp('status');
    addDateProp('createdDate');
    addDateProp('invitedDate');
    addDateProp('emailConfirmedDate');

    const options = columnDataBuilder.build();

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);

    const addStringField = (label: string, optionsName: string) =>
      fieldMetaDataBuilder.add(label, optionsName, 'string', FilterOperators.StringDefaults, options.get(optionsName));

    const addDateField = (label: string, optionsName: string) =>
      fieldMetaDataBuilder.add(label, optionsName, 'date', FilterOperators.DateDefaults, options.get(optionsName));

    addStringField('Email Address', 'email');
    addStringField('User Type', 'role');
    addStringField('Linked By', 'linkedBy');
    addStringField('Linked To', 'linkedTo');
    addStringField('With Access To', 'withAccessTo');
    addStringField('Status', 'status');
    addDateField('Created Date', 'createdDate');
    addDateField('Invited Date', 'invitedDate');
    addDateField('Email Confirmed Date', 'emailConfirmedDate');
  }

  getFilterFields(): Field[] {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }
}
